import { Divider } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Permissoes from '../Permissoes';

export default function PreferenciasPlataforma({
  selectedPermissions,
  setSelectedPermissions,
}) {
  return (
    <>
      <Divider orientation="left">Preferências da Plataforma</Divider>

      <Permissoes
        selectedPermissions={selectedPermissions}
        setSelectedPermissions={setSelectedPermissions}
        withGroup={true}
        isDisabled={false}
      />
    </>
  );
}

const PropTypesPermissionsId = PropTypes.shape({
  id: PropTypes.number,
  rule: PropTypes.string,
});

PreferenciasPlataforma.propTypes = {
  setSelectedPermissions: PropTypes.func.isRequired,
  selectedPermissions: PropTypes.arrayOf(PropTypesPermissionsId).isRequired,
};
